import React, { useCallback, useContext, useMemo } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { IItemForGetShortInfo, UserRoles, ITotalPrice } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import MultipleSelect from './components/MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './IsDisabledField.module.scss';

interface IIsDisabledField {
	isDisabledInRestaurants: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
	totalPrices: ITotalPrice[];
	externalId: string;
	setDisabledInRestaurants: (value: string[]) => void;
}

const IsDisabledField: React.FC<IIsDisabledField> = ({
	isDisabledInRestaurants,
	fetchedRestaurants,
	totalPrices,
	externalId,
	setDisabledInRestaurants,
}) => {
	const { loggedUser } = useContext<IAppContext>(AppContext);
	const hasAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);

	const handleRemove = useCallback(
		(id: string) => {
			const updatedSelectedItems = isDisabledInRestaurants.filter((el) => el !== id);
			setDisabledInRestaurants(updatedSelectedItems);
		},
		[isDisabledInRestaurants, setDisabledInRestaurants],
	);

	const restaurantsList = useMemo(() => {
		return isDisabledInRestaurants.map((el) => {
			const accessibleRestaurantIds = loggedUser.restaurants?.map((el) => el.id);
			const label = fetchedRestaurants.find((rest) => rest.id === el)?.name || '';
			return (
				<SelectedItem
					key={el}
					label={label}
					// onDelete={!hasAccess && !accessibleRestaurantIds?.includes(el) ? undefined : () => handleRemove(el)}
					onDelete={
						!!externalId || !(hasAccess || accessibleRestaurantIds?.includes(el))
							? undefined
							: () => handleRemove(el)
					}
				/>
			);
		});
	}, [isDisabledInRestaurants, loggedUser, fetchedRestaurants, hasAccess, handleRemove]);

	return (
		<div className={style.container} data-test="IsDisabledField">
			<div className={style.field}>
				<MultipleSelect
					isDisabledInRestaurants={isDisabledInRestaurants}
					totalPrices={totalPrices}
					externalId={externalId}
					setDisabledInRestaurants={setDisabledInRestaurants}
				/>
			</div>
			<div className={style.restaurantsList}>{restaurantsList}</div>
		</div>
	);
};

export default React.memo(IsDisabledField);
